module.exports = __webpack_public_path__ + "img/FaveActiveWhiteStroke.ddcfe4f5.svg";